import { useEffect } from 'react'

interface SEOHeadProps {
  title: string
  description: string
  type?: 'website' | 'article'
  image?: string
}

const SITE_NAME = 'Ads ROAS Calculator'
const DEFAULT_IMAGE = 'https://lumi.new/lumi.ing/logo.png'

function setNamedMeta(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function setPropertyMeta(property: string, content: string) {
  let tag = document.querySelector(`meta[property="${property}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('property', property)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function SEOHead({ title, description, type = 'website', image = DEFAULT_IMAGE }: SEOHeadProps) {
  useEffect(() => {
    const fullTitle = `${title} | ${SITE_NAME}`
    const url = window.location.href

    document.title = fullTitle
    setNamedMeta('description', description)

    setPropertyMeta('og:title', fullTitle)
    setPropertyMeta('og:description', description)
    setPropertyMeta('og:type', type)
    setPropertyMeta('og:url', url)
    setPropertyMeta('og:site_name', SITE_NAME)
    setPropertyMeta('og:image', image)
    setPropertyMeta('og:locale', 'en_US')

    setNamedMeta('twitter:card', 'summary_large_image')
    setNamedMeta('twitter:title', fullTitle)
    setNamedMeta('twitter:description', description)
    setNamedMeta('twitter:image', image)
  }, [title, description, type, image])

  return null
}

export default SEOHead
